<template>
  <div class="summary-wrapper">
    <div class="form-row">
      <div class="columns">
        <div>
          <div class="error-box">
            <h2 v-html="$t('view.component.topup.single.error.header')"></h2>
            <p v-html="$t('view.component.topup.single.error.text1')"></p>
          </div>
          <div class="phones-wrapper" v-if="topups">
            <div class="phone-box-wrapper-mobile">
              <TopupSinglePartialTopupPhonesBox :topups="topups" />
            </div>
          </div>
          <div class="desc">
            <p class="bold" v-html="$t('view.component.topup.single.error.text2')"></p>
            <div v-if="transaction">
              <p v-html="$t('view.component.topup.single.error.text3')"></p>
              <p v-html="$t('view.component.topup.single.error.text4', {orderId: transaction.orderId})"></p>
            </div>
            <button type="button" @click="goToTopup" class="primary">
              {{ $t('view.component.topup.single.error.button') }}
            </button>
          </div>
        </div>
        <div class="phones-wrapper" v-if="topups">
          <div class="phone-box-wrapper-desktop">
            <TopupSinglePartialTopupPhonesBox :topups="topups" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopupSinglePartialTopupPhonesBox from '@/orange/components/Topup/Single/PartialTopupPhonesBox'
import { ROUTING } from '@/orange/const/routing.const'
export default {
  name: 'TopupSingleError',
  components: { TopupSinglePartialTopupPhonesBox },
  props: {
    transaction: {
      type: Object,
      required: false,
      default: null
    },
    topups: {
      type: Array,
      required: false,
      default: null
    }
  },
  methods: {
    goToTopup () {
      this.$router.push(ROUTING.topup.single.step1)
    }
  }
}
</script>
<style lang="scss" src="../../../assets/scss/components/_topup-summary.scss" scoped></style>
